module.exports = __webpack_public_path__ + "img/shiyanshi.e2cacc48.png";